import { translateUi } from "./i18n.ts";
export type JitsiEvent = { id?: string; role?: string; muted?: boolean; isFatal?: boolean; type?: string };
export type JitsiApi = {
  executeCommand(command: string, ...args: unknown[]): void;
  addListener(event: string, listener: (event: JitsiEvent) => void): void;
  getNumberOfParticipants?(): number;
  dispose(): void;
};
export type JitsiApiConstructor = new (domain: string, options: Record<string, unknown>) => JitsiApi;

declare global {
  interface Window { JitsiMeetExternalAPI?: JitsiApiConstructor }
}

const pending = new Map<string, Promise<JitsiApiConstructor>>();

export function loadJitsiApi(domain: string): Promise<JitsiApiConstructor> {
  const existing = pending.get(domain);
  if (existing) return existing;
  const promise = new Promise<JitsiApiConstructor>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://${domain}/external_api.js`;
    script.async = true;
    let complete = false;
    const finish = (error?: Error) => {
      if (complete) return;
      complete = true;
      window.clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      if (error || !window.JitsiMeetExternalAPI) {
        script.remove(); pending.delete(domain);
        reject(error || new Error(translateUi("Video-thirrja nuk u ngarkua.", "The video call could not be loaded.")));
      } else resolve(window.JitsiMeetExternalAPI);
    };
    const timeout = window.setTimeout(() => finish(new Error(translateUi("Video-thirrja nuk u përgjigj me kohë.", "The video call did not respond in time."))), 20_000);
    script.onload = () => finish();
    script.onerror = () => finish(new Error(translateUi("Lidhja me shërbimin e video-thirrjes dështoi.", "The connection to the video call service failed.")));
    document.head.appendChild(script);
  });
  pending.set(domain, promise);
  return promise;
}
